export function handleSearchFlights(data) {
  const outboundFlight = data.OutBoundFlight;
  const inboundFlight = data.InBoundFlight;

  // Align pre-quote structure with post-quote structure
  if (!outboundFlight.Vias) outboundFlight.Vias = outboundFlight.AirportCodeVias;
  if (!inboundFlight.Vias) inboundFlight.Vias = inboundFlight.AirportCodeVias;
  
  return {
    outboundFlight,
    inboundFlight
  }
}

export function handleQuoteFlights(data) {
  const outboundFlight = routeMapper(data.FlightRouteSummary.OutBoundRoute, data.Flights[0].LuggageAllowance, data, true);
  const inboundFlight = routeMapper(data.FlightRouteSummary.InBoundRoute, data.Flights[1].LuggageAllowance, data, false);

  return {
    outboundFlight,
    inboundFlight
  }
}

function routeMapper(flight, luggage, data, isOutbound) {
  const route = {};
  let inBoundIndex = data.Flights.length - 1;

  if (flight.Vias.length > 0) {
    // This is the first inbound flight number.
    // We can't take the last index when there are vias otherwise the flight number on web will not match travelink.
    // E.G: Inbound contains two flights with 1 stopover. We want the flight number of the one going to the stopover.
    // Not the final destination.
    inBoundIndex = inBoundIndex - flight.Vias.length;
  }

  const flightIndex = isOutbound ? 0 : inBoundIndex;
  route.AirlineCode = flight.AirlineCode;
  route.AirlineLogoUrl = flight.AirlineLogoUrl;
  route.AirlineName = flight.AirlineName;
  route.AirportNameFrom = flight.DepartureAirportName;
  route.AirportCodeFrom = flight.DepartureAirportCode;
  route.AirportNameTo = flight.ArrivalAirportName;
  route.AirportCodeTo = flight.ArrivalAirportCode;
  route.DepartureDateTime = flight.DepartureTime;
  route.ArrivalDateTime = flight.ArrivalTime;
  route.TotalNumberOfAvailableBags = getTotalNumberOfAvailableBags(data);
  route.LuggageAllowance = luggage;
  route.CabinClass = data.Flights[flightIndex].Flights.CabinClass;
  route.FlightNumber = data.Flights[flightIndex].Flights.FlightNumber;

  if (flight.Vias.length) {
    route.AirportNameVia = flight.Vias[0].AirportName;
    route.AirportNameViaHour = flight.Vias[0].HourWait;
    route.AirportNameViaMinute = flight.Vias[0].MinuteWait;
    route.Vias = flight.Vias;
    route.AirportCodeVias = flight.Vias;
  } else {
    route.AirportNameVia = null;
    route.Vias = [];
    route.AirportCodeVias = [];
  }
  return route;
}

function getTotalNumberOfAvailableBags(basketData) {
  let totalNumberOfAvailableBags = 0;

  if (basketData.Passengers && basketData.Passengers.Passengers) {
    totalNumberOfAvailableBags = basketData.Passengers.Passengers.reduce((sum, passenger) => {
      if (passenger.PassengerTypeValue === "Adult" || passenger.PassengerTypeValue === "Child") {
        return sum += 1
      } else {
        return sum;
      }
    },0);
  }

  return totalNumberOfAvailableBags;
}